export { default as LightingBoltSolidIcon } from './LightingBoltSolidIcon';
